import { Link, useNavigate } from "react-router-dom";
import { useState, useEffect } from "react";
import SupportedIndustriesSection from "./components/SupportedIndustriesSection";
import PricingSection from "./components/PricingSection";



export default function Home() {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  async function handleLoginSubmit(e) {
    e.preventDefault();
    setLoading(true);

    try {
      const response = await fetch(
        "https://api.showmeyourjunk.biz/api/vendor/login",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ email, password }),
        }
      );

      const data = await response.json();

      if (!response.ok || !data.success) {
        alert(data.error || "Login failed. Check email and password.");
        setLoading(false);
        return;
      }

      localStorage.setItem("vendor_token", data.vendor_token);
      localStorage.setItem("vendor_id", data.vendor_id);
      navigate("/dashboard");
    } catch (err) {
      console.error("Login error:", err);
      alert("A network or server error occurred.");
    }

    setLoading(false);
  }

  return (
    <div style={pageStyle}>
      <div
        style={{
          width: "100%",
          maxWidth: isMobile ? "100%" : "900px", // lock desktop width
          margin: "0 auto",                      // center it
          padding: isMobile ? 0 : 0,            // optional: nice mobile gutters
          boxSizing: "border-box",
        }}
      >
        
        {/* HERO IMAGE + LOGIN */}
        <section
          style={{
            marginTop: 10,
            position: "relative",
            background:
              "radial-gradient(circle at center, rgba(59,130,246,0.14), transparent 70%)",
            paddingBottom: 10,
            textAlign: isMobile ? "center" : "left",
          }}
        >
          <div
            style={{
              fontSize: 42,
              fontWeight: 700,
              letterSpacing: "-0.02em",
              textAlign: isMobile ? "center" : "left",
            }}
          >
            Kevin's Leads
          </div>

          <div
            style={{
              fontSize: 17,
              maxWidth: 720,
              marginTop: 8,
              textAlign: isMobile ? "center" : "left",
              color: "#334155",
            }}
          >
            An AI-powered estimate and intake system that works directly on your
            website.
          </div>

          <div
            style={{
              display: "grid",
              gridTemplateColumns: isMobile ? "0.96fr" : "1fr 380px",
              gap: 15,
              margin: "0 auto",
              maxWidth: 880,
              alignItems: "start",
              justifyContent: isMobile ? "center" : "start",
            }}
          >
            {/* IMAGE CARD */}
            <div
              style={{
                borderRadius: 24,
                textAlign: "center",
              }}
            >
              <img
                src="/images/NEW-leadvision-hero-group.png"
                alt="LeadVision AI intake system"
                style={{
                  width: "100%",
                  height: "auto",
                  borderRadius: 15,
                  objectFit: "cover",
                  paddingTop: 10,
                }}
              />
            </div>

            <div
              style={{
                marginTop:isMobile ? -30 : 5,
                fontSize: 15,
                color: "#64748b",
                maxWidth: "100%",
                textAlign: isMobile ? "center" : "left",
                fontWeight: 500,
              }}
            >
              <div
                style={{
                  position: "relative",
                  marginBottom: 1,
                  padding: 10,
                  paddingTop: 15,
                  fontSize: 18,
                }}
              >
                We create quality customer leads by turning customer photos into
                structured estimates and clear next steps — without phone calls,
                guessing, or wasted site visits.
              </div>

              {/* LOGIN CARD */}
              <div
                style={{
                  position: "relative",
                  width: isMobile ? "85%" : 350,
                  maxWidth: isMobile ? "85%" : 350,
                  marginBottom: 1,
                  background: "#ffffff",
                  borderRadius: 24,
                  padding: 20,
                  paddingTop: 15,
                  margin: "0 auto",
                  boxShadow: "0 18px 36px rgba(0,0,0,0.16)",
                  zIndex: 5,
                }}
              >
                <div
                  style={{
                    fontSize: 22,
                    fontWeight: 700,
                    letterSpacing: "-0.02em",
                    textAlign: "left",
                    paddingBottom:10,
                  }}
                >
                  LeadVision Login
                </div>

                <form onSubmit={handleLoginSubmit}>
                  <div style={formRowStyle}>
                    <label style={formLabelStyle}>Email</label>
                    <input
                      type="email"
                      required
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      style={formInputStyle}
                    />
                  </div>

                  <div style={formRowStyle}>
                    <label style={formLabelPasswordStyle}>Password</label>
                    <input
                      type="password"
                      required
                      value={password}
                      onChange={(e) => setPassword(e.target.value)}
                      style={formInputPasswordStyle}
                    />
                  </div>


                  <button
                    type="submit"
                    disabled={loading}
                    style={buttonStyle(loading)}
                  >
                    {loading ? "Logging in..." : "Login"}
                  </button>
                </form>

                <div style={{ marginTop: 12, fontSize: 14 }}>
                  <Link to="/forgot-password">Forgot password?</Link>
                </div>

                <div style={{ marginTop: 10, fontSize: 14 }}>
                  <Link to="/signup">Create Free Vendor Account →</Link>
                </div>
              </div>
            </div>
          </div>

 {/* 3-CARD FEATURE SECTION (matches screenshot) */}
        <section style={{ 
          marginTop: 18, 
          marginBottom: 28,
          textAlign: isMobile ? "center" : "left",  
          }}
          >
          <div
            style={{
              display: "grid",
              gridTemplateColumns: isMobile ? "minmax(0, 420px)" : "repeat(3, 290px)",
              gap: 22,
              width: "90%",
              maxWidth: isMobile ? "90%" : "100%",
              margin: "0 auto",                 // ✅ centers the whole grid
              justifyContent: "center",          // ✅ centers grid tracks when narrower
            }}
          >

            {/* CARD 1 */}
            <div style={featureCardStyle}>
              <div style={featureIconWrapStyle}>
                <svg
                  width="72"
                  height="72"
                  viewBox="0 0 72 72"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  style={{ display: "block" }}
                >
                  <path
                    d="M24 28l-6 6c-3.3 3.3-3.3 8.7 0 12l8 8c3.3 3.3 8.7 3.3 12 0l6-6"
                    stroke="#2563eb"
                    strokeWidth="3"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M48 44l6-6c3.3-3.3 3.3-8.7 0-12l-8-8c-3.3-3.3-8.7-3.3-12 0l-6 6"
                    stroke="#2563eb"
                    strokeWidth="3"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <circle
                    cx="54"
                    cy="18"
                    r="6"
                    stroke="#2563eb"
                    strokeWidth="3"
                  />
                  <circle
                    cx="18"
                    cy="54"
                    r="6"
                    stroke="#2563eb"
                    strokeWidth="3"
                  />
                </svg>
              </div>

              <div style={featureTitleStyle}>
                Lead Generation: <br />100% Exclusively Yours
              </div>

              <div style={featureBodyStyle}>
                Get 100% exclusive homeowner leads, guaranteed. We never share
                your opportunities with other contractors. This will give you
                more influence, higher trust and a better chance of winning each
                job.
              </div>

              <a
                href="#"
                onClick={(e) => e.preventDefault()}
                style={featureLinkStyle}
              >
                Leads belong 100% to you! <span aria-hidden>→</span>
              </a>
            </div>

            {/* CARD 2 */}
            <div style={featureCardStyle}>
              <div style={featureIconWrapStyle}>
                <svg
                  width="72"
                  height="72"
                  viewBox="0 0 72 72"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  style={{ display: "block" }}
                >
                  <path
                    d="M36 18c8.8 0 16 7.2 16 16v6c0 2.2 1.8 4 4 4H16c2.2 0 4-1.8 4-4v-6c0-8.8 7.2-16 16-16Z"
                    stroke="#2563eb"
                    strokeWidth="3"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M28 50c1.3 2.4 4.4 4 8 4s6.7-1.6 8-4"
                    stroke="#2563eb"
                    strokeWidth="3"
                    strokeLinecap="round"
                  />
                  <path
                    d="M24 32h6M42 32h6"
                    stroke="#2563eb"
                    strokeWidth="3"
                    strokeLinecap="round"
                  />
                  <path
                    d="M18 26c-3 0-6 2.7-6 6.5S15 39 18 39"
                    stroke="#2563eb"
                    strokeWidth="3"
                    strokeLinecap="round"
                  />
                  <path
                    d="M54 26c3 0 6 2.7 6 6.5S57 39 54 39"
                    stroke="#2563eb"
                    strokeWidth="3"
                    strokeLinecap="round"
                  />
                  <path
                    d="M14 18h44"
                    stroke="#94a3b8"
                    strokeWidth="3"
                    strokeLinecap="round"
                    strokeDasharray="4 6"
                  />
                </svg>
              </div>

              <div style={featureTitleStyle}>
                After-Hours Call Center:
                <br />
                Never Miss a Lead Again
              </div>

              <div style={featureBodyStyle}>
                If your office is closed when leads call, you could lose
                business. Our AI call center works 7 days a week, up to 15
                hours daily, answering your calls, capturing leads and making
                appointments for you.
              </div>

              <a
                href="#"
                onClick={(e) => e.preventDefault()}
                style={featureLinkStyle}
              >
                Learn More <span aria-hidden>→</span>
              </a>
            </div>

            {/* CARD 3 */}
            <div style={featureCardStyle}>
              <div style={featureIconWrapStyle}>
                <svg
                  width="72"
                  height="72"
                  viewBox="0 0 72 72"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  style={{ display: "block" }}
                >
                  <path
                    d="M18 22h36a4 4 0 0 1 4 4v28a4 4 0 0 1-4 4H18a4 4 0 0 1-4-4V26a4 4 0 0 1 4-4Z"
                    stroke="#2563eb"
                    strokeWidth="3"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M22 18v8M50 18v8"
                    stroke="#2563eb"
                    strokeWidth="3"
                    strokeLinecap="round"
                  />
                  <path
                    d="M14 30h44"
                    stroke="#2563eb"
                    strokeWidth="3"
                    strokeLinecap="round"
                  />
                  <path
                    d="M24 38h6M24 46h6M36 38h6M36 46h6"
                    stroke="#2563eb"
                    strokeWidth="3"
                    strokeLinecap="round"
                  />
                  <path
                    d="M56 52a8 8 0 1 1-16 0 8 8 0 0 1 16 0Z"
                    stroke="#94a3b8"
                    strokeWidth="3"
                  />
                  <path
                    d="M48 48v5l3 2"
                    stroke="#94a3b8"
                    strokeWidth="3"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </div>

              <div style={featureTitleStyle}>
                Appointment Setting:<br /> We Handle 
                Outreach for You
              </div>

              <div style={featureBodyStyle}>
                We can take care of all your prospect outreach, follow-ups and
                calendar scheduling with a guaranteed set rate, so your team can
                stay focused on closing deals.
              </div>

              <a
                href="#"
                onClick={(e) => e.preventDefault()}
                style={featureLinkStyle}
              >
                Ask about guaranteed rates<span aria-hidden>→</span>
              </a>
            </div>
          </div>
        </section>

        

       

        {/* WHAT YOU’RE SUBSCRIBING TO */}
        <section style={{ margin:25 }}>
          <h2 style={sectionTitle}>What You’re Subscribing To</h2>

          <li style={listStyle}>
            An AI-powered estimate generator embedded on your own website
          </li>
          <li style={listStyle}>
            Prospective customer photos with automated item recognition and
            pricing
          </li>
          <li style={listStyle}>
            Structured estimates with automated weight, volume, and item counts
          </li>
          <li style={listStyle}>
            Clean handoff directly to your business — no need to sell to the
            customer!
          </li>

          <p style={mutedText}>
            Think of LeadVision as an AI receptionist and estimator — not a
            marketplace, not a lead broker, and not a guarantee engine.
          </p>
        </section>

        {/* SUPPORTED INDUSTRIES */}
        <section style={{ marginTop: 10, marginBottom: 10 }}>
          <SupportedIndustriesSection />
        </section>

        {/* PRICING */}
        <section style={{ marginTop: 10 }}>
          <PricingSection />
        </section>
      </section>
      </div>
    </div>
    
  );
}

/* ---------- Shared Styles ---------- */



const buttonStyle = (loading) => ({
  width: "100%",
  padding: "12px",
  borderRadius: 10,
  border: "none",
  background: "#2563eb",
  color: "#ffffff",
  fontWeight: 600,
  cursor: loading ? "not-allowed" : "pointer",
  opacity: loading ? 0.7 : 1,
});

const sectionTitle = {
  fontSize: 24,
  fontWeight: 800,
  marginBottom: 10,
  paddingLeft: 8,
};

const mutedText = {
  maxWidth: 800,
  color: "#64748b",
  marginTop: 16,
  lineHeight: 1.6,
};

const listStyle = {
  maxWidth: 800,
  lineHeight: 1.8,
  color: "#334155",
  marginLeft: 15,
};

/* ---------- Feature Cards (3-up) ---------- */

const featureCardStyle = {
  background: "#f1f5f9",
  borderRadius: 20,
  padding: 8,
  paddingTop:1,
  boxShadow: "0 10px 28px rgba(15, 23, 42, 0.08)",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  textAlign: "center",
  borderStyle: "solid",
  borderColor: "rgba(108, 151, 251, 0.91)",
  borderWidth:"1px",
  
};

const featureIconWrapStyle = {
  width: 94,
  height: 94,
  borderRadius: 999,
  background: "#eef2f7",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  marginBottom: 1,
};

const featureTitleStyle = {
  fontSize: 19,
  fontWeight: 800,
  letterSpacing: "-0.02em",
  color: "#0f172a",
  lineHeight: 1.15,
  marginTop: 1,
  marginBottom: 14,
};

const featureBodyStyle = {
  fontSize: 16,
  lineHeight: 1.7,
  color: "#0f172a",
  opacity: 0.9,
  maxWidth: 380,
  marginBottom: 1,
  textAlign:"left",
  paddingLeft:15,
  paddingRight:4,
};

const featureLinkStyle = {
  marginTop: "auto",
  fontSize: 18,
  color: "#2563eb",
  textDecoration: "none",
  fontWeight: 600,
  paddingTop: 10,
  paddingBottom: 10,
};

const formRowStyle = {
  display: "grid",
  gridTemplateColumns: "65px 1fr", // fixed label column
  alignItems: "center",
  gap: 12,
  marginBottom: 14,
};

const formLabelStyle = {
  fontSize: 15,
  fontWeight: 600,
  color: "#64748b",
  textAlign: "right"
};

const formLabelPasswordStyle = {
  fontSize: 15,
  fontWeight: 600,
  color: "#64748b",
  textAlign: "right",
};


const formInputStyle = {
  width: "85%",
  padding: "12px 14px",
  borderRadius: 14,
  border: "1px solid #cbd5e1",
  outline: "none",
  fontSize: 16,
  background: "#eef4ff",
};

const formInputPasswordStyle = {
  width: "60%",
  padding: "14px 16px",
  borderRadius: 14,
  border: "1px solid #cbd5e1",
  outline: "none",
  fontSize: 15,
  background: "#eef4ff",
};
const pageStyle = {
  minHeight: "100dvh", // dynamic viewport height (mobile-safe)
  width: "100vw", // force full viewport width
  overflowX: "hidden", // prevent right-side gutter
  background:
    "linear-gradient(180deg, #f8fafc 0%, #f0fdf4 35%, #ffffff 100%)",
  fontFamily:
    '-apple-system, BlinkMacSystemFont, "Inter", "Segoe UI", Roboto, Helvetica, Arial, sans-serif',
  color: "#0f172a",
  margin: 0,
  padding: 0,
  
};